import { render, staticRenderFns } from "./DealershipFilter.vue?vue&type=template&id=e2545b54&"
import script from "./DealershipFilter.vue?vue&type=script&lang=js&"
export * from "./DealershipFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports